
































import VueI18n from 'vue-i18n';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { DialogType } from '@/utils/consts';

@Component
export default class MessageDialog extends Vue {
  @Prop()
  private dialogType!: DialogType;

  @Prop()
  private dialogTitle!: VueI18n.TranslateResult;

  @Prop({ required: false, default: '' })
  private dialogText!: VueI18n.TranslateResult;

  @Prop({ required: false, default: false })
  private showSecondaryBtn!: boolean;

  private dialog: boolean = true;

  private get iconColor() {
    switch (this.dialogType) {
      case DialogType.Warning:
        return '#ff0000';
      case DialogType.Info:
        return '#1976d2';
      default: {
        const inspector: never = this.dialogType;
        return '#1976d2';
      }
    }
  }

  private get iconName() {
    switch (this.dialogType) {
      case DialogType.Warning:
        return 'mdi-alert-outline';
      case DialogType.Info:
        return 'mdi-information-outline';
      default: {
        const inspector: never = this.dialogType;
        return 'mdi-information-outline';
      }
    }
  }

  @Emit('pressed-secondary-btn')
  private emitSecondaryBtnAction() {
    return true;
  }

  @Emit('pressed-primary-btn')
  private emitPrimaryBtnAction() {
    return true;
  }
}
